import React from 'react'
import ReactDOM from 'react-dom/client'
import '@/assets/css/index.css'
import { message } from 'antd'
import App from '@/App'
import i18n, { i18nReady } from '@/locales'
import {
  consumeTranslationReloadNotice,
  patchDomForTranslation,
} from '@/utils/patchDomForTranslation'

// 允许浏览器机翻，挂载前接管翻译改写文本节点引发的 removeChild/insertBefore 崩溃（改为刷新页面）
patchDomForTranslation()

async function enableMocking() {
  if (process.env.REACT_APP_ENABLE_MOCK !== 'true') return
  const { worker } = await import('@/mocks/browser')
  return worker.start({
    onUnhandledRequest: 'warn',
    serviceWorker: { url: '/mockServiceWorker.js' },
  })
}

// 当前语言包按需加载（#1224），就绪后再挂载，首屏不闪裸 key；加载彻底失败也照常
// 挂载（显示 key），不能因语言包白屏
Promise.all([enableMocking(), i18nReady.catch(() => undefined)]).then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(<App />)

  const loading = document.getElementById('global-loading')
  if (loading) loading.remove()

  // 上次加载因翻译崩溃被自动刷新：告知运营刷新原因，避免误以为页面异常
  if (consumeTranslationReloadNotice()) {
    message.warning(i18n.t('error.translationReload'), 6)
  }
})
